import { lazy } from 'react'
import type { OwnProps } from 'd2/screens/PasswordConfirmation/types'

const PasswordConfirmation = lazy<React$ComponentType<OwnProps>>(() => import('d2/screens/PasswordConfirmation'))
export default PasswordConfirmation
